/**
 * API Service for Video Creator App
 * Handles all communication with User Backend
 */

// CRITICAL: User Backend URL - always use app.loopai.in
const API_BASE_URL = 'https://app.loopai.in';

/**
 * Fetch available AI models from Admin Backend
 * @returns {Promise<Array>} Array of capabilities
 */
export async function fetchAvailableModels() {
  try {
    // Get API key and user email from sessionStorage
    const apiKey = sessionStorage.getItem('apiKey');
    const userEmail = sessionStorage.getItem('userEmail');
    
    const headers = {
      'Content-Type': 'application/json'
    };
    
    if (apiKey) headers['X-API-Key'] = apiKey;
    if (userEmail) headers['X-User-Email'] = userEmail;
    
    const response = await fetch(`${API_BASE_URL}/api/ai/available-models`, {
      method: 'GET',
      credentials: 'include',
      headers
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    const data = await response.json();
    return data.capabilities || [];
  } catch (error) {
    console.error('Failed to fetch AI models:', error);
    throw error;
  }
}

/**
 * Check if user is authenticated
 * @returns {Promise<Object>} User data
 */
export async function checkAuth() {
  const apiKey = sessionStorage.getItem('apiKey');
  const userEmail = sessionStorage.getItem('userEmail');
  
  const headers = {
    'Content-Type': 'application/json'
  };
  
  if (apiKey) headers['X-API-Key'] = apiKey;
  if (userEmail) headers['X-User-Email'] = userEmail;
  
  const response = await fetch(`${API_BASE_URL}/api/auth/me`, {
    method: 'GET',
    credentials: 'include',
    headers
  });

  if (!response.ok) {
    throw new Error('Not authenticated');
  }

  return response.json();
}

/**
 * Get user credits
 * @returns {Promise<Object>} Credits data
 */
export async function getCredits() {
  const apiKey = sessionStorage.getItem('apiKey');
  const userEmail = sessionStorage.getItem('userEmail');
  
  const headers = {
    'Content-Type': 'application/json'
  };
  
  if (apiKey) headers['X-API-Key'] = apiKey;
  if (userEmail) headers['X-User-Email'] = userEmail;
  
  const response = await fetch(`${API_BASE_URL}/api/credits`, {
    method: 'GET',
    credentials: 'include',
    headers
  });

  if (!response.ok) {
    throw new Error('Failed to fetch credits');
  }

  return response.json();
}

export default {
  fetchAvailableModels,
  checkAuth,
  getCredits
};
